import { render, staticRenderFns } from "./onlinePayments.vue?vue&type=template&id=ef076894&scoped=true&"
import script from "./onlinePayments.vue?vue&type=script&lang=ts&"
export * from "./onlinePayments.vue?vue&type=script&lang=ts&"
import style0 from "./onlinePayments.vue?vue&type=style&index=0&id=ef076894&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef076894",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCardText})
